import { render, staticRenderFns } from "./Ignis.vue?vue&type=template&id=4aa73d15&"
import script from "./Ignis.vue?vue&type=script&lang=ts&"
export * from "./Ignis.vue?vue&type=script&lang=ts&"
import style0 from "./Ignis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports